// Form rules of the admin page "Check-in / check-out settings". They mirror the ranges enforced by the server
// (libs/inspectionAdmin.js, which refuses out-of-range values): this only gives early feedback.

export const SETTINGS_FIELDS = Object.freeze([
  { name: 'checkinOpensHoursBefore', min: 0, max: 24 * 30, labelKey: 'inspAdmCheckinOpens', helpKey: 'inspAdmCheckinOpensHelp' },
  { name: 'checkoutWindowDays', min: 0, max: 90, labelKey: 'inspAdmCheckoutWindow', helpKey: 'inspAdmCheckoutWindowHelp' },
  { name: 'inspectionGraceHours', min: 0, max: 24 * 30, labelKey: 'inspAdmGraceHours', helpKey: 'inspAdmGraceHoursHelp' },
  { name: 'photoMax', min: 1, max: 8, labelKey: 'inspAdmPhotoMax', helpKey: 'inspAdmPhotoMaxHelp' },
  { name: 'photoMin', min: 0, max: 8, labelKey: 'inspAdmPhotoMin', helpKey: 'inspAdmPhotoMinHelp' },
  { name: 'disputeWindowDays', min: 0, max: 365, labelKey: 'inspAdmDisputeWindow', helpKey: 'inspAdmDisputeWindowHelp' }
]);

export const DEFAULT_FORM_SETTINGS = Object.freeze({
  inspectionEnabled: true, checkinOpensHoursBefore: 0, checkoutWindowDays: 7, inspectionGraceHours: 48, photoMax: 8, photoMin: 0, disputeWindowDays: 7
});

// Whole number inside [min, max]; anything else is null.
export function parseWholeNumber(text, min, max) {
  const trimmed = String(text === undefined || text === null ? '' : text).trim();
  if (!/^\d{1,4}$/.test(trimmed)) return null;
  const value = Number(trimmed);
  return value >= min && value <= max ? value : null;
}

// texts: { inspectionEnabled: boolean, <field>: string }. Returns { value, errors } ; errors maps a field to a message key.
export function parseSettingsForm(texts) {
  const errors = {};
  const value = { inspectionEnabled: Boolean(texts.inspectionEnabled) };
  SETTINGS_FIELDS.forEach(({ name, min, max }) => {
    const parsed = parseWholeNumber(texts[name], min, max);
    if (parsed === null) errors[name] = 'inspAdmErrRange';
    else value[name] = parsed;
  });
  if (!errors.photoMin && !errors.photoMax && value.photoMin > value.photoMax) errors.photoMin = 'inspAdmErrPhotoMinMax';
  return { value, errors };
}

export function settingsToTexts(settings) {
  const source = { ...DEFAULT_FORM_SETTINGS, ...(settings || {}) };
  const texts = { inspectionEnabled: Boolean(source.inspectionEnabled) };
  SETTINGS_FIELDS.forEach(({ name }) => { texts[name] = String(source[name]); });
  return texts;
}
